import { IconButton, styled } from '@project44/manifest-ds';

export const StyledIconButton = styled(IconButton, {
  width: '2rem',
});
